<template>
  <div class="container-fluid w-100 pb-3" style="overflow: hidden">
    <navbar v-if="!editMode" :title="$t('subscription.management_title')" />
    <div class="col-sm-12 nopads my-2">
      <Transition name="fade">
        <subscriptions-list
          :can-add="false"
          :results="results"
          @edit="editSubscription"
        />
      </Transition>
        <base-modal v-if="editMode" hide-footer hide-header size="lg">
            <subscription-editor
                :subscription-to-edit="subscription"
                :is-admin="isAdmin"
                @close="showList"
                @close-and-update="closeAndUpdate"
            />
        </base-modal>

      <div
        v-if="loading"
        id="loader"
        class="spinner"
      />
    </div>
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import SubscriptionsList from "./SubscriptionsList";
import SubscriptionEditor from "./SubscriptionEditor";
import Navbar from "@/components/utils/Navbar.vue";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'Subscriptions',
    components: {BaseModal, Navbar, SubscriptionEditor, SubscriptionsList},
    mixins: [restApi],
    props: {
        isAdmin: {type: Boolean, default: false}
    },
    data: function () {
        return {
            results: [],
            subscription: null,
            editMode: false,
            loading: true
        }
    },
    mounted: function () {
        this.fetchSubscriptions()
    },
    methods: {
        fetchSubscriptions: function () {
            this.loading = true
            this.restFetch(this.subscriptionUrl + '/all', this.handleResponse)
        },

        handleResponse: function (response) {
            this.loading = false
            this.results = response.data
        },

        editSubscription: function (subscription) {
            this.subscription = subscription
            this.editMode = true
        },

        showList: function () {
            this.editMode = false
        },

        closeAndUpdate: function () {
            this.fetchSubscriptions()
            this.showList()
        }
    }
}
</script>